export default __webpack_public_path__ + "static/office4-2x-2c08ed4f55da7cc875b086090574f12b.jpg";